import { filterModelName } from '../../utils/filterModelName';
import { SettingsDaiCostsResponse } from './types';

export const dataDaiCostsFilteredByName = (
  dataDaiCost: SettingsDaiCostsResponse,
  name: string | undefined
): SettingsDaiCostsResponse => {
  const trimmed = name?.trim() ?? '';
  if (trimmed === '') {
    return dataDaiCost;
  }

  const predicate = filterModelName(trimmed);

  const dataDaiCostFilteredByName = dataDaiCost.data.filter(
    (row) => row.kiMei.length > 0 && predicate(row.kiMei)
  );

  return {
    ...dataDaiCost,
    data: dataDaiCostFilteredByName,
  };
};
